import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type NavGuardState = {
  blocked: boolean;
};

const initialState: NavGuardState = {
  blocked: false,
};

const navGuardSlice = createSlice({
  name: "navGuard",
  initialState,
  reducers: {
    setNavBlocked(state, action: PayloadAction<boolean>) {
      state.blocked = action.payload;
    },
  },
});

export const { setNavBlocked } = navGuardSlice.actions;
export default navGuardSlice.reducer;
